import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * The shared ATASKAITOS section header — the period-end surfaces navigate as one
 * group: the report pages + the close wizard (Uždarymas joined Ataskaitos by
 * product decision 2026-09-08; it has no top-nav item of its own — its other
 * entries are the Darbai close card and Ctrl+K).
 */
const REPORT_ROUTES = [
  { to: '/reports/vat', key: 'reports.nav.vat' },
  { to: '/reports/vat-declaration', key: 'reports.nav.declaration' },
  { to: '/reports/financial-statements', key: 'reports.nav.financial' },
  { to: '/reports/debt-aging', key: 'reports.nav.debtAging' },
  { to: '/reports/cash-book', key: 'reports.nav.cashBook' },
  { to: '/reports/account-statement', key: 'reports.nav.accountStatement' },
  { to: '/reports/debt-statement', key: 'reports.nav.debtStatement' },
  { to: '/uzdarymas', key: 'reports.nav.close' },
  { to: '/reports/saft', key: 'reports.nav.saft' },
];

export default function ReportsNav() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-1 border-b border-gray-200 pb-2">
      <span className="text-xs font-semibold uppercase text-gray-400 mr-2">{t('reports.nav.title')}</span>
      {REPORT_ROUTES.map(r => (
        <NavLink
          key={r.to}
          to={r.to}
          className={({ isActive }) =>
            `px-3 py-1 text-xs font-medium rounded-full border transition-colors ${
              isActive
                ? 'bg-primary-50 border-primary-300 text-primary-700'
                : 'bg-white border-gray-200 text-gray-600 hover:border-gray-400'
            }`
          }
        >
          {t(r.key)}
        </NavLink>
      ))}
    </div>
  );
}
